var map = {
	"./canceled.svg": "./src/assets/transaction-status/canceled.svg",
	"./complete.svg": "./src/assets/transaction-status/complete.svg",
	"./expired.svg": "./src/assets/transaction-status/expired.svg",
	"./failed.svg": "./src/assets/transaction-status/failed.svg",
	"./pending.svg": "./src/assets/transaction-status/pending.svg",
	"./refunded.svg": "./src/assets/transaction-status/refunded.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/transaction-status sync recursive ^\\.\\/.*\\.svg$";